import type { MailingListSignupResult } from "@diality/ui";
import { getAnalytics } from "../analytics/configured-analytics";
import { apiUrl, resolveApiEndpoint } from "./api-endpoint";

export async function submitMailingListSignup(
  email: string,
): Promise<MailingListSignupResult> {
  try {
    const endpoint = await resolveApiEndpoint();
    const response = await fetch(apiUrl(endpoint, "/api/subscribers"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (response.ok) {
      const body = (await response.json().catch(() => null)) as {
        status?: string;
      } | null;
      if (body?.status !== "subscribed") return "unavailable";
      // Both the footer and authored signup blocks use this success boundary.
      try {
        getAnalytics()?.publish({ type: "newsletter-signup" });
      } catch {
        // Measurement must not turn a received signup into a visitor-facing error.
      }
      return "subscribed";
    }

    // The platform judged the address unusable and sent nothing.
    if (response.status === 400) return "invalid-email";

    // Anything else says nothing about the address — invite a retry rather than
    // implying it was rejected.
    return "unavailable";
  } catch {
    return "unavailable";
  }
}
